import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';
import Add from '@mui/icons-material/Add';

import { Button } from 'uikit/buttons';
import { Tooltip } from 'uikit/tooltips';
import ReactionsListItem from './reactionsListItem';

import styles from '../styles/uikitReactionsList.module.scss';

const ReactionsList = ({
  addReactionId = null,
  reactions,
  className = '',
  onReactionClick = null,
  onAddReactionClick = null,
  addReactionTooltipText = 'Add Reaction',
  testId = '',
}) => {
  if (!reactions || !reactions.length) return null;

  return (
    <ul className={classnames(styles.element, className)} data-testid={testId}>
      {reactions.map((reaction) => (
        <Tooltip
          content={reaction.tooltipText}
          key={`reactions-list-${reaction.emoji}-tooltip`}
          placement="top"
        >
          <ReactionsListItem
            reaction={reaction}
            onClick={onReactionClick}
            className={className}
            testId={reaction.testId}
          />
        </Tooltip>
      ))}
      <Tooltip content={addReactionTooltipText} placement="top">
        <Button
          className={classnames(styles.add, className)}
          id={addReactionId}
          variant="ghost"
          size="xsmall"
          icon={<Add />}
          ariaLabel={i18n.t('chat.emoji-picker-open-aria-label')}
          onClick={onAddReactionClick}
        />
      </Tooltip>
    </ul>
  );
};

ReactionsList.propTypes = {
  addReactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  reactions: PropTypes.arrayOf(PropTypes.shape({
    emoji: PropTypes.string,
    count: PropTypes.number,
    name: PropTypes.string,
    isSelected: PropTypes.bool,
    tooltipText: PropTypes.string,
    testId: PropTypes.string,
  })).isRequired,
  onReactionClick: PropTypes.func,
  onAddReactionClick: PropTypes.func,
  addReactionTooltipText: PropTypes.string,
  testId: PropTypes.string,
};

export default React.memo(ReactionsList);
